import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerService } from '../../shared/services/customer/customer.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionsComponent implements OnInit {
  subscription : any = {};
  constructor(private customerService: CustomerService) { }

  ngOnInit() {
    this.customerService.subscription().subscribe(r => {
      this.subscription = r;
    })
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/subscriptions/subscriptions.component.ts